import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImportContainer} from 'app/Model/dataProcess/importContainer';
import {ProductDataSource} from 'app/Model/dataProcess/productDataSource';
import {DataSourcesService} from 'app/Services/DataProcess/datasources.service';
import {ImportContainerService} from 'app/Services/DataProcess/import-container.service';
import {LoginService} from 'app/Services/login.service';
import {DxFileUploaderTypes} from 'devextreme-angular/ui/file-uploader';
import {BeforeSendEvent} from 'devextreme/ui/file_uploader';
import {OAuthService} from 'angular-oauth2-oidc';
import {TranslateService} from '@ngx-translate/core';
import {SystemService} from 'app/Services/system.service';

@Component({
  selector: 'np-container-edit',
  templateUrl: './container-edit.component.html',
  styleUrls: ['./container-edit.component.css'],
  standalone: false
})
export class ContainerEditComponent implements OnInit {
  private _visible = false;

  @Input()
  set visible(value: boolean) {
    this._visible = value;
    this.visibleChange.emit(this._visible);
  }

  get visible(): boolean {
    return this._visible;
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() container: ImportContainer;
  @Input() editMode = false;

  @Output() onSaved = new EventEmitter<ImportContainer>();
  @Output() onCanceled = new EventEmitter<void>();

  fullScreen = false;
  supplierEditVisible: boolean = false;
  supplierEditMode: boolean = false;

  suppliers: ProductDataSource[] = [];
  selectedSupplier: ProductDataSource = null;

  constructor(
    private importContainerService: ImportContainerService,
    private dataSourceService: DataSourcesService,
    public loginService: LoginService,
    private oAuthService: OAuthService,
    private translate: TranslateService,
    private systemService: SystemService
  ) {
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  async ngOnInit(): Promise<void> {
    await this.loadSuppliers();
  }

  toggleFullScreen(): void {
    this.fullScreen = !this.fullScreen;
  };

  onBeforeSendUpload(event: BeforeSendEvent): void {
    event.request.withCredentials = true;
    event.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  onUploaded(e: DxFileUploaderTypes.UploadedEvent): void {
    this.container.logoLink = e.request.responseText as string;
  }

  async onSave(): Promise<void> {
    this.container.lastChanged = new Date();
    this.container = await this.importContainerService.update(this.container, this.loginService.currentCustomer.id);

    this.systemService.notifyInfo(this.translate.instant(
      this.editMode
        ? 'Katalog-Container wurde geändert'
        : 'Katalog-Container wurde angelegt'));

    this.onSaved.emit(this.container);
    this.visible = false;
  }

  onCancel(): void {
    this.visible = false;
  }

  showCreationOfSupplier() {
    this.supplierEditMode = false;
    this.selectedSupplier = null;
    this.supplierEditVisible = true;
  }

  showEditOfSupplier() {
    this.supplierEditMode = true;
    let foundSupplier = this.suppliers.find(x => x.id == this.container.dataSourceId);
    if (foundSupplier) {
      this.selectedSupplier = foundSupplier;
      this.supplierEditVisible = true;
    } else {
      this.systemService.notifyInfo(this.translate.instant('Lieferant auswählen'));
    }
  }

  async onSupplierSaved(supplier: ProductDataSource): Promise<void> {
    await this.loadSuppliers();
    if (supplier?.id) {
      this.container.dataSourceId = supplier.id;
    }
  }

  async loadSuppliers(): Promise<void> {
    this.suppliers = await this.dataSourceService.getAll(this.loginService.currentCustomer.id) ?? [];
  }
}
